import React from 'react';
import Row from 'react-bootstrap/Row';
import Carousel from 'react-bootstrap/Carousel';
import { TrustedHtmlString } from '../../models/globals';
import { ReviewItem } from './ReviewItem';
import { ProductSection, ProductSectionProps } from '../common/ProductSection';
import { chunkArray } from '../../utilities/ArrayUtilities';
import DownArrow from '../../svgs/downarrow.svg';

interface ReviewProps extends ProductSectionProps {
    reviews: TrustedHtmlString[];
}

const Review: React.FC<ReviewProps> = ({ reviews, ...productSectionProps }) => {
    if (!reviews.length) return null;

    const reviewChunks: string[][] = chunkArray(reviews, 2);

    return (
        <ProductSection {...productSectionProps}>
            <Carousel
                className="mt-4 pb-5 d-md-none"
                id="reviewsCarouselMobile"
                interval={null}
                indicators={reviews.length > 1}
                controls={false}
                wrap={false}
                data-testid={'reviews-carousel-mobile'}
            >
                {reviews.map((quotes, i) => {
                    return (
                        <Carousel.Item key={i}>
                            <Row>
                                <ReviewItem quote={quotes} className="reviews-icon-small" />
                            </Row>
                        </Carousel.Item>
                    );
                })}
            </Carousel>
            <Carousel
                className="mt-4 pb-5 d-none d-md-block"
                id="reviewsCarousel"
                interval={null}
                indicators={reviewChunks.length > 1}
                controls={reviewChunks.length > 1}
                nextIcon={<DownArrow aria-hidden="true" className="arrow-next text-dark" />}
                prevIcon={<DownArrow aria-hidden="true" className="arrow-prev text-dark" />}
                wrap={false}
                data-testid={'reviews-carousel'}
            >
                {reviewChunks.map((quotes, i) => {
                    return (
                        <Carousel.Item key={i}>
                            <Row className="mx-0">
                                {quotes.map((quote) => (
                                    <ReviewItem quote={quote} key={quote} className="reviews-icon-large" />
                                ))}
                            </Row>
                        </Carousel.Item>
                    );
                })}
            </Carousel>
        </ProductSection>
    );
};

export { Review, ReviewProps };
